import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { I18n } from "aws-amplify/utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { tlmPostAccountNumberInactive } from "layouts/dashboard/apiService";
import { APIStatusDialog } from "components/APIStatusDialog";
import { DateTimeField } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
dayjs.extend(utc);

const InactivateStoreDialog = ({ open, onClose, accountNumber, onCloseNote ,setStoreStatus}) => {
  const [endDate, setEndDate] = useState(null);
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  useEffect(() => {
    if (open) {
      setEndDate(null); // Reset endDate each time the dialog opens
    }
  }, [open]);

  const handleSave = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Store Reactivation"),
      });
  
      const formattedEndDate = endDate ? dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss") : ""; // Check if endDate is empty
      const restOperation = await tlmPostAccountNumberInactive(accountNumber, formattedEndDate);
      const response = await restOperation.response;
  
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Store successfully reactivated"),
        });
        setStoreStatus('inactive'); 
        onCloseNote();
        onClose();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to reactivate store"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to reactivate store"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };
  

  return (
    <Dialog open={open} onClose={onClose} >
      <DialogTitle>{I18n.get("Suspend Store")}</DialogTitle>
      <DialogContent>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimeField
        label="End Date"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
       format="YYYY/MM/DD HH:mm"
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                padding: '4px',
                fontSize: '14px',
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} color="primary">
          {I18n.get("Save")}
        </Button>
        <Button onClick={onClose}>{I18n.get("Cancel")}</Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
};

export default InactivateStoreDialog;
